// src/lang/index.ts
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'
import zhCN from './cn.json'  // 注意导入的变量名不能包含短横线

Vue.use(VueI18n)

// 定义消息类型
interface Messages {
  [key: string]: any
}

const messages: Messages = {
  en,
  'zh-CN': zhCN  // 这里使用字符串作为键
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: localStorage.getItem('APP_LANG') || 'zh-CN', // 默认语言，与 messages 中的键保持一致
  fallbackLocale: 'en', // 备用语言
  messages,  // 使用上面定义的 messages 对象
  silentTranslationWarn: true // 禁止警告
})

export default i18n